import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Tome-removebg-preview.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            ALLOW ME TO <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
            I love programming, at least learned something I guess..... 💁‍♂️
              <br />
              <br />I am good at
              <i>
                <b className="purple"> C#, Javascript, Python and Swift. </b>
              </i>
              <br />
              <br />
              My mission is to create new&nbsp;
              <i>
                <b className="purple">websites, apps for IOS</b> and 
                develop games on the{" "}
                <b className="purple">
                Unity engine.
                </b>
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for product development using <b className="purple">Node.js</b> and modern Javascript libraries and frameworks such as
              <i>
                <b className="purple">{" "}React.js and Next.js.
                </b>
              </i>
              &nbsp; And I don't forget about
              <i>
                <b className="purple">{" "}Python projects,</b>
              </i>
              &nbsp; and modern libraries and frameworks like
              <i>
                <b className="purple">{" "}Django and Flask as well</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/n1k7777"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/n1k_7777/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/n1k_7777/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
